import React from "react"
import NavLink from "../NavLink"
import { useStaticQuery, graphql, Link } from "gatsby"

const Header = () => {
  const allData = useStaticQuery(graphql`
    query {
      allNavHeaderMenuJson {
        edges {
          node {
            name
            title
            slug
          }
        }
      }
    }
  `)
  const data = allData.allNavHeaderMenuJson.edges
  if (data.length <= 0) {
    return <></>
  }
  return (
    <header>
      <nav className="navbar navbar-expand-lg">
        <div className="container-xl">
          <div className="nav-header">
            <button
              type="button"
              className="navbar-toggler"
              data-bs-toggle="collapse"
              data-bs-target="#navbar-motherhost"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>

            <NavLink
              className="navbar-brand"
              to="/"
              title="Motherhost Logo"
              aria-label="Click here to Navigate Motherhost Home Page"
            >
              <img
                src="/img/logo/motherhost-logo-blue.svg"
                className="logo"
                alt="Motherhost logo"
              />
            </NavLink>
            <ul className="d-flex w-100 justify-content-end d-lg-none">
              <li className="nav-item me-1">
                <a
                  className="btn btn-mh btn-outline-primary"
                  href="mailto:support@motherhost.com"
                >
                  <i className="bi bi-envelope-fill"></i>
                </a>
              </li>
              <li className="nav-item me-1">
                <a
                  className="btn btn-mh btn-outline-primary"
                  href="tel:+919884678464"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-telephone-fill"></i>
                </a>
              </li>
              <li className="nav-item">
                <Link
                  className="btn btn-mh btn-outline-primary"
                  role="button"
                  aria-pressed="true"
                  to="/login/"
                  title="Login with Motherhost account"
                >
                  <i className="bi bi-arrow-right"></i>
                </Link>
              </li>
            </ul>
          </div>
          <div id="navbar-motherhost" className="collapse navbar-collapse">
            <ul className="navbar-nav me-auto">
              {data.map((item, index) => (
                <li className="nav-item" key={index}>
                  <NavLink
                    to={item.node.slug}
                    title={item.node.title}
                    className="nav-link"
                  >
                    {item.node.name}
                  </NavLink>
                </li>
              ))}
            </ul>
            <ul className="navbar-nav ms-auto d-none d-lg-flex">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Sign In
                  <i className="me-1 bi bi-chevron-down"></i>
                </a>
                <ul
                  className="dropdown-menu shadow "
                  style={{ width: "320px", padding: "24px 16px" }}
                >
                  <li>
                    <span className="mb-3 fw-bold d-block">
                      Registered Users
                    </span>
                    <span className="mb-3 d-block">
                      Have an account? Sign in now.
                    </span>
                    <Link
                      className="mt-3"
                      role="button"
                      aria-pressed="true"
                      to="/login/"
                      title="Login with Motherhost account"
                    >
                      Sign In
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider my-3" />
                  </li>
                  <li>
                    <span className="mb-3 fw-bold d-block"> New Customer</span>
                    <span className="mb-3 d-block">
                      New to Motherhost? Create an account to get started today.
                    </span>
                    <a
                      className="mt-3"
                      href="https://my.motherhost.com/register.php"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Create an Account
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <a
                  href="tel:+919884678464"
                  className="nav-link d-flex"
                 
                >
                  <span>
                    24/7 - 0988-467-8464
                    {/* <br />
                    <small style={{fontSize: "10px"}}>(24x7 Sales &amp; Support)</small> */}
                  </span>
                  <img
                    src="/img/icons/india-flag.png"
                    alt="India"
                    title="India"
                    className="ms-1"
                    height={22}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
